<template>
  <notifications id="pop-countdown" group="pop-coudown">
    <template slot="body" slot-scope="props">
      <div class="vue-notification">
        <div class="row mt-5 mb-5">
          <div class="col-sm-1"><a class="btn-close" @click="props.close">&#10006;</a></div>
          <div class="col-sm-10"><span>{{$t('pop-countdown-mess')}} {{minutes}} mins {{seconds}} secs</span></div>
        </div>
      </div>
    </template>
  </notifications>
</template>
<style>
  #pop-countdown .notification-wrapper .vue-notification {
    background-color: black !important;
    border-left: black !important;
  }
  #pop-countdown {
    padding: 5px !important;
  }
  #pop-countdown .btn-close{
    float: left;
    color: white;
    font-size: 18px;
  }
</style>
<script>
  import moment from 'moment'
  export default {
    data() {
      return {
        date :0,
        now: 0,
        timezone : '',
        isShow : false,
        itervalObj : null,
        quote_time : 0
      }
    },

    mounted() {
      this.$root.$on('showPopUpClosing', () => {
        this.init()
      })
      this.$root.$on('closePopUpClosing', () => {
        this.closePopup()
      })
    },

    created() {
      this.init()
    },

    computed: {
      seconds() {
        return (this.date - this.now) % 60;
      },

      minutes() {
        return Math.trunc((this.date - this.now) / 60) % 60;
      },

      hours() {
        return Math.trunc((this.date - this.now) / 60 / 60) % 24;
      },

      days() {
        return Math.trunc((this.date - this.now) / 60 / 60 / 24);
      }
    },
    methods : {
      setInterval() {
        this.itervalObj = setInterval(() => {
          this.now = Math.trunc((new Date()).getTime() / 1000);
          if(this.hours <= 0 && this.minutes <= this.quote_time) {
            if(this.isShow == false){
              this.isShow = true
              this.openPopup()
            }
          }
          if(this.hours <= 0 && this.minutes <= 0){
            this.isShow = false
            this.$forceUpdate(this.isShow)
            this.$session.remove('cart')
            this.$session.remove('disposition')
            this.$router.push('/')
            this.closePopup()
          }
        },1000);
      },
      openPopup(){
        this.$notify({
          group : 'pop-coudown',
          duration : -1
        });
      },

      closePopup(){
        this.$notify({
          group : 'pop-coudown',
          clean : true
        });
        if(this.itervalObj){
          clearInterval(this.itervalObj)
        }
      },

      /*
      * Get Info OutLet
      * Time to show popup is Closing time - Quote time
      * */
      init() {
        let id = this.$disposition.getByKey(this, 'outletId', '')
        let collectiontime = this.$disposition.getByKey(this,'collectionTimeValue','')
        if(id && !collectiontime) {
          var vm = this
          let order_type = this.orderType || this.$disposition.getByKey(this, 'orderType', 'D')
          this.axios.apiOutlet.getOutletOpeningHours({outletId: id, order_type: order_type.charAt(0)}, function (response) {
            let items = response.data.data.items
            if (!vm.empty(items)) {
              vm.timezone = items[0].info.timezone
              vm.now = Math.trunc(moment().tz(vm.timezone) / 1000)
              for(let i of items){
                if(i.date == moment().tz(vm.timezone).format('YYYY-MM-DD')){
                  let endTime = vm.convertUTCToTimeZone(i.date + ' ' + i.info.end_time, vm.timezone)
                  vm.quote_time = i.info.quote_time
                  vm.date = Math.trunc(endTime / 1000)
                  break;
                }
              }
              if(vm.now && vm.date)
                vm.setInterval()
            } else {
              vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)
              if (order_type && order_type.charAt(0).toUpperCase() == vm.$const.CARRYOUT.charAt(0)) {
                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_MODAL_PICKUP, true)
              } else {
                vm.callEventBus(vm.$const.EVENT_BUS.SHOW_MODAL_DELIVERY, true)
              }
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/HomeCountDownTimerCloseOutlet.vue